import { render, staticRenderFns } from "./register.vue?vue&type=template&id=03fb5a2e"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./register.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLink: require('/vercel/path0/components/shared/AppLink.vue').default,CornerButton: require('/vercel/path0/components/shared/CornerButton.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default})
